import FluentValidator from '@/app/module/fluentValidator'

class DviValidator extends FluentValidator {
  public validRequiredDviParam (key: string, value: string|number): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = 'DVIパラメータの値は必ず入力してください。'
      return false
    }
    return true
  }
  public validRequiredIdealWaterLevel (key: string, value: string|number): boolean {
    this.errorMessages[key] = ''
    if (!value) {
      this.errorMessages[key] = '理想水位(cm)の値は必ず入力してください。'
      return false
    }
    return true
  }
}

export default new DviValidator()
